import * as ActionTypes from '../../actions/ActionTypes';
import CategoryOrganizationBufferedChangesRecord from '../../records/organize/CategoryOrganizationBufferedChangesRecord';
const INITIAL_STATE = new CategoryOrganizationBufferedChangesRecord();
export default function categoryOrganizationBufferedChanges(state = INITIAL_STATE, {
  error,
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.CATEGORY_ORGANIZATION_HAS_BUFFERED_CHANGES_PENDING:
      return state.merge({
        hasLocalChanges: false,
        isRequesting: true
      });
    case ActionTypes.CATEGORY_ORGANIZATION_HAS_BUFFERED_CHANGES_SUCCESS:
      return state.merge({
        hasBufferedChanges: payload.has_changes || payload.hasChanges,
        isRequesting: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'undefined... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.CATEGORY_ORGANIZATION_HAS_BUFFERED_CHANGES_ERROR:
      return state.merge({
        error,
        isRequesting: false
      });
    case ActionTypes.UPDATE_ARTICLE_ORDERING_SUCCESS:
    case ActionTypes.UPDATE_CATEGORY_ORDERING_SUCCESS:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_SUCCESS:
      return state.set('hasLocalChanges', true);
    case ActionTypes.CATEGORY_ORGANIZATION_PUSH_BUFFER_LIVE_SUCCESS:
      return state.merge({
        hasBufferedChanges: false,
        hasLocalChanges: false
      });
    case ActionTypes.CATEGORY_ORGANIZATION_PUSH_BUFFER_LIVE_POLLING_STARTED:
      return state.set('isPolling', true);
    case ActionTypes.CATEGORY_ORGANIZATION_PUSH_BUFFER_LIVE_POLLING_ENDED:
      return state.set('isPolling', false);
    case ActionTypes.CLEAR_ORGANIZE_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
}